import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Section } from '../components/Section';
import { PostRow } from '../components/PostRow';
import { PUBLISHED, findPost } from '../data/posts';
export function Post() {
  const {
    slug = ''
  } = useParams();
  const post = findPost(slug);
  if (!post) {
    return <section className="sec nt" data-id="element-633" data-mp="belp4p2qvjbr">
        <div className="sec-m" data-id="element-634" data-mp="bfelcw42uqfn">
          <div className="sec-n" data-id="element-635" data-mp="191lsacnusuv6">SIGNALS</div>
          <Link className="sec-l" to="/blog" data-id="element-636" data-mp="190aoicuern42">
            ← All Signals
          </Link>
        </div>
        <div className="sec-c page-hero" data-id="element-637" data-mp="142ra9cxpnac4">
          <h1 className="h1" data-id="element-638" data-mp="zazjp2ek14lz">That one isn’t here.</h1>
          <p className="lede" data-id="element-639" data-mp="z9g298h5wnim">The piece you followed has moved or never existed. The index has everything we’ve published.</p>
          <div data-id="element-640" data-mp="uabpy8yxy9o2">
            <Link className="btn btn-o" to="/blog" data-id="element-641" data-mp="1rra9z42p2esl">
              All Signals →
            </Link>
          </div>
        </div>
      </section>;
  }
  const headings = post.body.filter((b): b is {
    t: 'h2';
    x: string;
  } => b.t === 'h2').map(b => b.x);

  // Newest-first order: read next is the two pieces after this one, wrapping.
  const i = PUBLISHED.findIndex(p => p.slug === post.slug);
  const next = PUBLISHED.length > 1 ? [1, 2].map(k => PUBLISHED[(i + k) % PUBLISHED.length]).filter(p => p.slug !== post.slug) : [];
  return <>
      <section className="sec nt" data-id="element-642" data-mp="286rktkzioeqe">
        <div className="sec-m" data-id="element-643" data-mp="1u8kyn23xk36k">
          <div className="sec-n" data-id="element-644" data-mp="1u7i84vais2r6">SIGNALS</div>
          <Link className="sec-l" to="/blog" data-id="element-645" data-mp="1uanz6g2plepj">
            ← All Signals
          </Link>
        </div>
        <div className="sec-c page-hero" style={{
        paddingBottom: 48,
        gap: 22
      }} data-id="element-646" data-mp="1y7tqu2jbnt00">
          <div className="meta" style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          flexWrap: 'wrap'
        }} data-id="element-647" data-mp="1kc8647k4fvde">
            <span className="ptag" data-id="element-648" data-mp="1pbkskr72z0fg">{post.category.toUpperCase()}</span>
            <span className="dt" data-id="element-649" data-mp="3eppvm04372b2">
              <time dateTime={post.date} data-id="element-650" data-mp="3emll6l013aby">{post.dateLabel.toUpperCase()}</time> · {post.author.toUpperCase()}
            </span>
          </div>
          <h1 className="h1" style={{
          maxWidth: 900
        }} data-id="element-651" data-mp="3i6m0f89l194x">
            {post.title}
          </h1>
          <p className="lede" style={{
          maxWidth: 760
        }} data-id="element-652" data-mp="3d6znkzxo1uwn">
            {post.excerpt}
          </p>
        </div>
      </section>

      {post.hero && <div className="bleed phero" data-id="element-653" data-mp="38a8yjn3vvoz3">
          <img src={post.hero} alt="" data-id="element-654" data-mp="339l6cy3x523a" />
        </div>}

      <section className="sec nt" data-id="element-655" data-mp="33b656zx9n76y">
        <div className="sec-m" style={{
        gap: 14
      }} data-id="element-656" data-mp="4rz60zw1y4n6">
          <div className="sec-n" data-id="element-657" data-mp="4qo0auj1qmtf">IN THIS PIECE</div>
          {headings.length > 0 && <div className="toc" data-id="element-658" data-mp="3vy8vj4rsgbm4">
              {headings.map(h => <span key={h} data-id="element-659" data-mp="3r5z0xbfqandi">{h}</span>)}
            </div>}
        </div>
        <div className="sec-c" style={{
        gap: 0,
        paddingBottom: 72
      }} data-id="element-660" data-mp="3m6w6sm1ae1kb">
          <article className="prose" data-id="element-661" data-mp="nhnm5mv8vgih">
            {post.body.map((block, n) => {
            if (block.t === 'h2') return <h2 key={n} data-id="element-662" data-mp="iqp2cdb1s0ah">{block.x}</h2>;
            if (block.t === 'ul') return <ul key={n} data-id="element-663" data-mp="r0mqc5ns8stq">
                    {block.items.map((item, m) => <li key={m} data-id="element-664" data-mp="v0wurdvxfb6h" data-mpi={m}>{item}</li>)}
                  </ul>;
            if (block.t === 'link') return <p key={n} data-id="element-665" data-mp="102vzar3eke50">
                    <a className="plink" href={block.href} target="_blank" rel="noopener noreferrer" data-id="element-666" data-mp="1505llxvhw9om">
                      {block.label} →
                    </a>
                  </p>;
            return <p key={n} data-id="element-667" data-mp="1dziwmuz9p6bg" data-mpi={n}>{block.x}</p>;
          })}
          </article>

          {next.length > 0 && <div className="readnext" data-id="element-668" data-mp="1iqr6tt8f8vpo">
              <div className="sec-n" data-id="element-669" data-mp="1irsrmpf8owkl">READ NEXT</div>
              <div className="plist" style={{
            maxWidth: 820
          }} data-id="element-670" data-mp="1nqdk22o92byh">
                {next.map(p => <PostRow key={p.slug} post={p} data-id="element-671" data-mp="1spzygfftdy8v" />)}
              </div>
            </div>}
        </div>
      </section>
    </>;
}